import { Molde } from "../services/TurnServices/Turns.type";

const practicesTypes = [
  "PRACTICE_IN_EXAM_IN_MOLDE",
  "PRACTICE_IN_MOLDE",
  "PRACTICE_IN_EXAM",
  "PRACTICE",
];

export const extractPracticesFromMetadata = (metadata: any, types = practicesTypes): Practice[] | null => {
  const { simplified } = metadata;

  return simplified?.filter((e: any) => types.includes(e.type)) || null;
};

export const extractMoldeFromMetadata = (metadata: any): Molde | null => {
  const { molde } = metadata;

  return molde
}

export const extractExamFromMetadata = (metadata: any): Exam | null => {
  const { simplified } = metadata;

  const practicesTypes = ["EXAM_IN_MOLDE", "EXAM"];

  return simplified?.find((e: any) => practicesTypes.includes(e.type)) || null;
};

export const extractJustExamFromMetadata = (metadata: any): Exam | null => {
  const { simplified } = metadata;

  const practicesTypes = ["EXAM"];

  if(simplified) return simplified.find((e: any) => practicesTypes.includes(e.type));
  if(metadata) return metadata.exam?.name
  return null
};

export const extractPracticesAndExamFromMetadata = (
  metadata: any,
): [Practice[] | null, Exam | null] => {
  const practices = extractPracticesFromMetadata(metadata);
  const exam = extractExamFromMetadata(metadata);

  return [practices, exam];
};

export const getExamReportStatus = (
  appointment: { status: string },
  exam: Exam,
) => {
  if (appointment.status === "Pendiente de completar") return "Procesando";

  if (appointment.status === "Finalizado" && exam?.fullReportUrl)
    return "Finalizado";

  return "Inválido";
};
